Vue.filter('currency', function (val) {
    let currencyType = typeof (Webservice.getSetting('currency_symbol') !== undefined) ? Webservice.getSetting('currency_symbol') : Webservice.getSetting('currency');
    return accounting.formatMoney(val, currencyType + " ", 2, ".", ",");
});

Vue.filter('dateFilter', function (val, format = 'LLL') {
    return moment(val).format(format);
});

Vue.filter('baseName', function (str) {
    var base = new String(str).substring(str.lastIndexOf('/') + 1);
    if (base.lastIndexOf(".") != -1)
        base = base.substring(0, base.lastIndexOf("."));
    return base;
});

Vue.filter('truncate', function (text, length) {
    if (text.length > length) {
      return text.substring(0, length) + '...'
    } else {
      return text
    }
});


// WEBPACK FOOTER //
// ./src/filters.js